import { render, staticRenderFns } from "./relatedGoods.vue?vue&type=template&id=f2b4219e&scoped=true"
import script from "./relatedGoods.vue?vue&type=script&lang=js"
export * from "./relatedGoods.vue?vue&type=script&lang=js"
import style0 from "./relatedGoods.vue?vue&type=style&index=0&id=f2b4219e&prod&lang=stylus&scoped=true"
import style1 from "./relatedGoods.vue?vue&type=style&index=1&id=f2b4219e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b4219e",
  null
  
)

export default component.exports